import type FondsDataService from './fonds.data-service';
import type {Fond} from 'typings/portaro.be.types';

/**
 * @ngdoc controller
 * @name fondsController
 * @module use-cases.fonds
 *
 * @requires Restangular
 *
 * @description
 * Controller
 */
export default class FondsController {

    public static getFonds(fondsDataService: FondsDataService): Promise<Fond[]> {
        return fondsDataService.getAll();
    }

    /*@ngInject*/
    constructor(public allFonds: Fond[]) {}

}
